module.exports = __webpack_public_path__ + "img/三段式操作台.34c22ad1.jpg";